import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {UserHeaderComponent} from "./user-header/user-header.component";
import {IonicModule} from "@ionic/angular";
import {WalletValueSectionComponent} from "./wallet-value-section/wallet-value-section.component";
import {EvolutionCardComponent} from "./evolution-card/evolution-card.component";
import {ContactCardComponent} from "./contact-card/contact-card.component";
import {TranslocoPipe} from "@ngneat/transloco";
import {ItemListComponent} from "./item-list/item-list.component";
import {ReactiveFormsModule} from "@angular/forms";
import {WalletPerformanceTableComponent} from './wallet-performance-table/wallet-performance-table.component';
import {ActivityFeedComponent} from './activity-feed/activity-feed.component';
import {WalletCompositionChartComponent} from './wallet-composition-chart/wallet-composition-chart.component';
import {ContentCardComponent} from './content-card/content-card.component';
import {BaseCardComponent} from './base-card/base-card.component';
import {BuildCmcUrlPipe} from '../core/pipes/buildCmcUrl/build-cmc-url.pipe';
import {BaseListComponent} from './base-list/base-list.component';
import {RouterModule} from '@angular/router';
import {DesktopSidepanelComponent} from "./desktop-sidepanel/desktop-sidepanel.component";
import {SheetModalComponent} from './sheet-modal/sheet-modal.component';
import {WalletSelectorComponent} from './wallet-selector/wallet-selector.component';
import {FormsModule} from '@angular/forms';
import {ErrorControlPipe} from "../core/pipes/error-control/error-control.pipe";
import {AccountNumberComponent} from './account-number/account-number.component';
import {ClosedWalletComponent} from './closed-wallet/closed-wallet.component';
import {ActiveUrlPipe} from '../core/pipes/activeUrl/active-url.pipe';
import {ManagerInsightComponent} from './manager-insight/manager-insight.component';
import {FormModalComponent} from './form-modal/form-modal.component';
import {FormlyModule} from '@ngx-formly/core';
import {FormlyIonicModule} from '@ngx-formly/ionic';
import {RequestCardComponent} from './request-card/request-card.component';
import {CustomIonInputComponent} from './custom-ion-input/custom-ion-input.component';
import {CustomIonFileComponent} from './custom-ion-file/custom-ion-file.component';
import {CustomIonSelectComponent} from './custom-ion-select/custom-ion-select.component';
import {CustomIonFormSectionComponent} from './custom-ion-form-section/custom-ion-form-section.component';
import {IssueModalComponent} from "./issue-modal/issue-modal.component";
import {MarkdownModule} from "ngx-markdown";
import { IssueCardComponent } from './issue-card/issue-card.component';
import { insufficientFundsValidator } from '../core/validators/insufficient-funds.validator';

@NgModule({
    declarations: [
        UserHeaderComponent,
        WalletValueSectionComponent,
        EvolutionCardComponent,
        ContactCardComponent,
        ItemListComponent,
        WalletPerformanceTableComponent,
        BaseListComponent,
        ActivityFeedComponent,
        WalletCompositionChartComponent,
        BaseCardComponent,
        ContentCardComponent,
        SheetModalComponent,
        WalletSelectorComponent,
        BuildCmcUrlPipe,
        ActiveUrlPipe,
        DesktopSidepanelComponent,
        AccountNumberComponent,
        ClosedWalletComponent,
        ManagerInsightComponent,
        FormModalComponent,
        RequestCardComponent,
        IssueCardComponent,
        ErrorControlPipe,
        IssueModalComponent
    ],

    imports: [
        IonicModule,
        CommonModule,
        TranslocoPipe,
        ReactiveFormsModule,
        RouterModule,
        FormsModule,
        MarkdownModule.forRoot(),
        FormlyModule.forRoot({
          wrappers: [
              {name: 'ion-section', component: CustomIonFormSectionComponent},
          ],
          types: [
              {name: 'ion-input', component: CustomIonInputComponent},
              {name: 'ion-select', component: CustomIonSelectComponent},
              {name: 'ion-file', component: CustomIonFileComponent},
          ],
          validators: [
            {name: 'insufficient-funds', validation: insufficientFundsValidator},
          ]
        }),
        FormlyIonicModule,
    ],
    exports: [
        UserHeaderComponent,
        WalletValueSectionComponent,
        EvolutionCardComponent,
        ContactCardComponent,
        WalletPerformanceTableComponent,
        ActivityFeedComponent,
        ItemListComponent,
        WalletCompositionChartComponent,
        BaseCardComponent,
        BaseListComponent,
        SheetModalComponent,
        ContentCardComponent,
        WalletSelectorComponent,
        DesktopSidepanelComponent,
        AccountNumberComponent,
        ClosedWalletComponent,
        ManagerInsightComponent,
        FormModalComponent,
        RequestCardComponent,
        IssueCardComponent,
        BuildCmcUrlPipe,
        ActiveUrlPipe,
        ErrorControlPipe,
        IssueModalComponent
    ]
})
export class UiUtilsModule {
}
